import { Typography } from "@backpac/monica";

export function BgmTerminationNotice() {
  return (
    <div className="rounded-xl bg-white shadow-[0px_1px_4px_0px_rgba(15,15,15,0.1)] p-12 mb-12">
      <div className="flex flex-col gap-6">
        <Typography size="lg" weight={600} className="text-[#F96900] leading-[1.2]">
          BackPac BGM Termination Notice
        </Typography>
        <div className="text-[#2F2F2F] text-[15px] font-normal leading-[1.4] whitespace-pre-wrap font-['Inter']">
          <div>
            The BackPac BGM service will be discontinued on September 30, 2025 (PT) due to changes in YouTube policies.
          </div>

          <div className="mt-6">
            <span className="font-semibold">Termination Policy:</span>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>
                <span className="font-semibold">Service End Date:</span> September 30, 2025 (PT) – All BGM will be
                unavailable.
              </li>
              <li>
                <span className="font-semibold">Monetization:</span> No further revenue will be generated even if BGM is
                used through the YouTube app.
              </li>
              <li>
                <span className="font-semibold">Existing Shorts:</span> Some tracks may be removed by YouTube, which can
                also remove BGM from existing videos.
              </li>
              <li>
                <span className="font-semibold">Revenue Payouts:</span>
                <ul className="list-disc list-inside ml-6 mt-1 space-y-1">
                  <li>Revenue earned until removal will be paid as usual.</li>
                  <li>After removal, no additional BGM revenue will be paid.</li>
                </ul>
              </li>
              <li>
                <span className="font-semibold">Withdrawal Deadline:</span> Revenue generated up to September 30 (PT)
                will remain available for withdrawal until December 31, 2025. Any unclaimed balance after this date will
                expire.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            👉 Please note: This termination applies only to the BGM service.
            <br />
            Our music campaign service will continue and grow as our primary focus.
          </div>

          <div className="mt-4">
            Thank you for your understanding and continued support.
            <br />
            The BackPac Team
          </div>
        </div>
      </div>
    </div>
  );
}
